import { API } from "aws-amplify";

/**
 * Get user profile bypassing any cache or CDN
 */
export default async (key) => {
  const { data } = await API.get("admin", `/user-profiles/${key}`);
  return data;
};
